import React from 'react';
import { Headings } from '../../components';
import { data } from '../../constants';
import { FiArrowUpRight, FiCheck } from 'react-icons/fi';
import './Services.css';

const Services = () => {
  return (
    <section id="capabilities" className="capabilities section-padding">
      <div className="site-container">
        <Headings title="AI product capabilities" text="Engineering patterns for data products, model-backed workflows, voice systems, and physical-world intelligence." />

        <div className="capability-grid">
          {data.ServicesData.map(({ eyebrow, title, description, link, itemclass, imgURL, points }, index) => (
            <article className={`capability-card ${itemclass}`} key={index}>
              <div className="capability-card-copy">
                <span>{eyebrow}</span>
                <h3>{title}</h3>
                <p>{description}</p>
                <ul>
                  {points.map((point) => (
                    <li key={point}><FiCheck /> {point}</li>
                  ))}
                </ul>
                <a href={link} className="readmore">Learn more <FiArrowUpRight /></a>
              </div>
              <img src={imgURL} alt="" className="img-services" />
            </article>
          ))}
        </div>
      </div>
    </section>
  )
}

export default Services
